import Cookies from 'js-cookie';

type DataLayerEvent = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: DataLayerEvent[];
  }
}

function pushToDataLayer(event: DataLayerEvent): void {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push(event);
}

export function trackPageView(): void {
  if (typeof window === 'undefined') return;

  const { hostname, href, pathname, search } = window.location;
  const { title } = document;
  const { userAgent } = window.navigator;

  const euid = Cookies.get('euid');

  pushToDataLayer({
    event: 'page_view',
    team: 'autoops',
    pagePath: pathname,
    pageURL: href,
    pageSearch: search,
    pageTitle: title,
    hostname,
    canonicalTag: href,
    euid,
    userAgent,
  });
}

export function trackLogin(cloudUserId: string): void {
  if (typeof window === 'undefined') return;

  pushToDataLayer({
    event: 'login',
    team: 'autoops',
    timestamp: new Date().toISOString(),
    pageURL: window.location.href,
    cloudUserId,
  });
}
